import styled from 'styled-components';

export const CustomerNeedsMainWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        margin-top:3rem;
        flex-direction:column;
        @media(max-width:1023px){
            margin-top:1rem;
        }
    `,
);

export const CustomerNeedsHeaderWrap = styled.div(
  props => `
        display: flex;
        flex-direction: column;
        @media(max-width:1023px){
            max-width:70%;
            margin:0 auto;
            align-items: center;
            justify-content: center;
        }
    `,
);

export const CustomerNeedsHeadText = styled.h3(
  props => `
        font-size:3.6rem;
        color: #2f281e;
        font-weight: 900;
        @media(max-width:1023px){
            font-size:2.4rem;
            text-align:center;
        } 
    `,
);

export const CustomerNeedsSubText = styled.p(
  props => `
        font-size: 2.4rem;
        color: #333333;
        @media(max-width:1023px){
            font-size: 1.4rem;
            text-align:center;
        }
    `,
);
